<script>
import carousel from 'vue-owl-carousel';

export default {
  name: 'ScrollLbs',
  components: { carousel },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    unit: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      container: null,
      localvalue: '---',
    };
  },
  beforeMount() {
    this.localvalue = this.value;
  },
  methods: {
    changed: function(e) {
      this.localvalue = e.item.index;
      this.$emit('value-changed', this.localvalue);
    },
    updated: function(e) {
      // console.log(e)
    },
  },
};
</script>

<template>
  <div>
    <div id="wrapper"
      >{{ localvalue === 0 ? '- - -' : localvalue }}<span>{{ unit }}</span></div
    >
    <carousel
      :autoplay="false"
      :nav="false"
      :center="true"
      :dots="false"
      :margin="5"
      :items="20"
      :autoWidth="true"
      @changed="changed"
      @updated="updated"
      @initialize="updated"
      @initialized="updated"
      @resize="updated"
      @resized="updated"
      @refresh="updated"
      @refreshed="updated"
      @update="updated"
      @drag="updated"
      @dragged="updated"
      @translate="updated"
      @translated="updated"
      @to="updated"
      :startPosition="localvalue"
    >
      <div v-for="i in 300" :key="i" class="item" style="width:10px">
        <h4 :class="i % 10 === 1 ? 'bar10' : i % 5 === 1 ? 'bar5' : 'bar1'"></h4>
      </div>
    </carousel>
  </div>
</template>

<style scoped>
/* stylelint-disable selector-max-type */
#wrapper {
  color: #4059e1;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 45px;
  font-style: normal;
  font-weight: bold;
  margin-bottom: 16px;
}

span {
  color: #000;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: normal;
  margin-left: 16px;
  margin-top: 5px;
  opacity: 0.5;
  position: absolute;
}

.bar5 {
  background: #c4c4c4;
  height: 60px;
  position: relative;
  top: 20px;
  width: 2px;
}

.bar1 {
  background: #c4c4c4;
  height: 40px;
  position: relative;
  top: 25px;
  width: 1px;
}

.bar10 {
  background: #c4c4c4;
  height: 80px;
  position: relative;
  top: 10px;
  width: 2px;
}

.owl-carousel.owl-drag .owl-item.center .item h4 {
  background: #4059e1;
  height: 100px;
  position: relative;
  top: 0;
  width: 3px;
}
</style>
